import React, { useState } from 'react';
import { Spin, Modal } from "antd";
import { Button, Form, Row } from "reactstrap";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { sendForgotPasswordRequest } from '../services/authApi';
import ImageLogin from "../../../assets/images/loginImg.png";
import logo from "../../../assets/images/Paxity.png";
import '../utils/forgot-password.css';
import FormField from '../../../common/Form/FormField';
import { toast } from "react-toastify";
import { MailOutlined } from '@ant-design/icons';
import Lottie from "lottie-react";
import mailSentAnim from "../../../assets/animations/password.json";
import mailVerifyAnim from "../../../assets/animations/mailAnimation.json";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [error, setError] = useState("");

  const frontUrl = process.env.REACT_APP_API_PASSWORD;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Veuillez renseigner une adresse email valide")
      .required("Veuillez renseigner l'adresse email"),
  });

  const initialValues = {
    email: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      setError("");
      const data = {
        email:values.email,
        frontUrl:frontUrl
      }
      try {
        await sendForgotPasswordRequest(data);
        setIsModalVisible(true);
      } catch (error) {
        setError(`Erreur : ${error?.response?.data?.message}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const handleOk = () => {
    formik.resetForm();
    navigate("/login-merchant");
    setIsModalVisible(false);
  };

  return (
    <div className="my-box d-flex">
      <div className="left-box">
        <img src={ImageLogin} alt="Logo" className="login-image" />
      </div>
      <div className="right-box">
        <div className="py-2 px-md-5">
          <div className="mt-0 mb-3">
            <img src={logo} alt="Logo" style={{ width: '167px', height: '39px' }} />
            <br/>
          </div>
          <div className="auth-heading-wrapper">
            <div className=" connected">Mot de passe oublié ?</div>
            <p className="texteLogin mt-1 mb-0">
              Pas de panique, renseignez juste votre email d'inscription et on vous envoie un lien de réinitialisation !
            </p>
          </div>
          <div style={{ width: 170, margin: "0 auto", marginBottom: 0 }}>
            <Lottie animationData={mailVerifyAnim} loop={true} autoplay />
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <FormField
                  label="Email *"
                  name="email"
                  formik={formik}
                  type="email"
                  colSize={12}
                  inputClassName="w-full p-2 rounded-[10px] text-base border-2 border-green-500"
                />
            </Row>
            <Button
              disabled={isLoading || !(formik.isValid && formik.dirty)}
              type="submit"
              style={{ backgroundColor: "#2848FF" }}
              className="login-btn mt-0"
            >
              {isLoading ? <Spin size="sm" /> : "Envoyer le lien"}
            </Button>
          </Form>
          <div className="text-center mt-3 label">
            Ah je me rappelle de mon compte ! {" "} <br/>
            <a href="/login-merchant" style={{ color: "#2848FF" }} >Se connecter</a>
          </div>
        </div>
          
      </div>

      <Modal
        title={null}
        open={isModalVisible}
        onCancel={handleOk}
        footer={[
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Button
            key="ok"
            type="primary"
            style={{
              backgroundColor: "#2848FF",
              borderRadius: "8px",
              width: "60%",
            }}
            onClick={handleOk}
          >
            Fermer
          </Button>,
          </div>
        ]}
        centered
        width={500}
        bodyStyle={{
          padding: "40px 30px",
          textAlign: "center",
          borderRadius: "12px",
        }}
      >
        <div style={{ width: 200, margin: "0 auto", marginBottom: 20 }}>
          <Lottie animationData={mailSentAnim} loop={true} autoplay />
        </div>

        <h2 style={{ fontWeight: 500 }}>
          Vérifiez votre boîte mail <MailOutlined style={{ color: "#2848FF" }} />
        </h2>

        <p style={{ fontSize: "16px", color: "#555", marginBottom: 0 }}>
          Un lien de réinitialisation a été envoyé à votre adresse.
          <br />
          Cliquez dessus pour modifier votre mot de passe.
        </p>
      </Modal>
    </div>
  );
};

export default ForgotPassword;
